var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDhconstunlit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 218,
    viewBox: "0 0 514 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.168 36.988L283 67.9513",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349 101.018L296 155.018",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M445.412 43.8268L396 99.8411",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M507.072 115.341L387.69 115.259",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M439.047 184.121L459.475 40.0057",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M357 89.0176L339.746 50.0176",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M364.509 163.987L288.71 169.967",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50.0176C52.021 41.5609 102.558 34.8135 120.291 69.436C126.727 89.8314 124.55 145.671 76.5 175.518",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeDasharray: "21.58 21.58"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66.0176L66.5 161.018",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.735 48.812L158.829 175.701",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173.805 108.387L218 86.0174",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M243 27.0179L226 176.018",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhconstunlit);
export default __webpack_public_path__ + "static/media/dhconstunlit.3d364d2ab553b0cdc7b9a5a4a5c73ae8.svg";
export { ForwardRef as ReactComponent };